import Common from '../Common';

const DataDeletion = class extends Common {
	delete = () =>
		this.doDelete(`/datadeletion`)
}

export default DataDeletion
